import React, { useState } from "react";
import { useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import CustomText from "pages/_components/CustomText/CustomText";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import MassiveEcheckSummaryBody from "./massiveEcheckSummaryBody";

const MassiveEcheckSummary = ({ isDesktop }) => {
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const { massiveEcheckData, echeckTicket } = useSelector((state) => state.echecks);
    useConfirmTransaction(massiveEcheckData, echeckTicket, "massiveEchecks/newEcheq");

    return (
        <>
            <Notification scopeToShow="massiveEcheckSummary" />
            <ResponsiveHeader id="massive.echeck.title" />
            <MainContainer>
                <CustomText text="Controlá los datos" textType="TEXT" className="custom-text custom-data-title" />
                <MassiveEcheckSummaryBody
                    accountInfo={massiveEcheckData?.accountInfo}
                    file={massiveEcheckData?.file}
                    typePayment={massiveEcheckData?.typePayment}
                    dateProcess={massiveEcheckData?.dateProcess}
                    processedFileData={massiveEcheckData?.processedFileData}
                    isDesktop={isDesktop}
                    setShowMoreData={setShowMoreData}
                    showMoreData={showMoreData}
                    isSummary
                />
                <GeneralCredentialForm
                    transactionData={massiveEcheckData}
                    action={echeckActions.validateMassiveEcheq}
                    idActivity="load.echeq.massive"
                    hideIndications
                />
            </MainContainer>
        </>
    );
};

MassiveEcheckSummary.propTypes = {
    isDesktop: bool.isRequired,
};

export default MassiveEcheckSummary;
